$(document).ready(function () {

  var $header = $(".custom-header");
  var $announcement = $(".announcement-bar"); // adjust selector
  var $announcementBarContainer = $(".announcement-bar-section");

  function updateHeaderOffset() {
    var barHeight = $announcement.outerHeight() || 0;
    document.documentElement.style.setProperty("--header-offset", barHeight + "px");
  }

  function updateHeaderState() {
    if ($(window).scrollTop() > 0) {
      $header.addClass("active-header");
      $announcementBarContainer.addClass("active-header");
      // document.documentElement.style.setProperty("--header-offset", "0px");
    } else {
      $header.removeClass("active-header");
      $announcementBarContainer.removeClass("active-header");
      let barHeightUpd = $announcement.outerHeight() || 0;
      // document.documentElement.style.setProperty("--header-offset", barHeight + "px");
    }
  }

  updateHeaderOffset();
  updateHeaderState();

  $(window).on("resize", updateHeaderOffset);

  $(window).on("scroll", updateHeaderState);

  // Tile Service Hover Effect

  function initTileHover() {
    // Remove previous hover handlers to avoid duplicates
    $('.custom-tile--block .grid-block--each').off('mouseenter mouseleave');

    if (window.matchMedia('(min-width: 1025px)').matches) {
      $('.custom-tile--block .grid-block--each').hover(
        function () {
          var $tile = $(this);
          var $content = $tile.find('.grid-block--each__content');
          var $heading = $tile.find('.grid-block--each__heading');

          // Measure height safely
          var wasHidden = !$content.is(':visible');
          if (wasHidden) {
            $content.css({ visibility: 'hidden', display: 'block' });
          }
          var contentHeight = $content.outerHeight(true);
          if (wasHidden) {
            $content.css({ display: 'none', visibility: '' });
          }

          $heading.stop(true, true).animate({ bottom: contentHeight + 25 }, 300);
          $content.stop(true, true).slideDown(300);
        },
        function () {
          var $tile = $(this);
          var $content = $tile.find('.grid-block--each__content');
          var $heading = $tile.find('.grid-block--each__heading');

          $heading.stop(true, true).animate({ bottom: 0 }, 300);
          $content.stop(true, true).slideUp(300);
        }
      );
    }
  }

  // Run on load
  // initTileHover();

  // Re-check on resize
  // $(window).on('resize', initTileHover);


  // Number Counter

  // if ($('.counter-block').length) {

  //   const observerOptions = {
  //     root: null,
  //     rootMargin: '0px',
  //     threshold: 0.1
  //   };

  //   function observerCallback(entries, observer) {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {

  //         $(entry.target).find('span.integer__').each(function () {
  //           const $this = $(this);
  //           console.log(this.data('integer'));
  //           $this.prop("Counter", 0).animate(
  //             {
  //               Counter: $this.text(),
  //             },
  //             {
  //               duration: 1000,
  //               easing: "swing",
  //               step: function (now) {
  //                 now = Math.ceil(now); // ← no commas
  //                 $this.text(now);
  //               },
  //             }
  //           );

  //           observer.unobserve(entry.target);
  //         });
  //       }
  //     });
  //   }

  //   const observer = new IntersectionObserver(observerCallback, observerOptions);

  //   $('.counter-block').each(function () {
  //     observer.observe(this);
  //   });

  // }

  if ($('.counter-block').length) {

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    function observerCallback(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          $(entry.target).find('.integer__').each(function () {
            const $this = $(this);

            // ✅ get clean number
            const target = parseInt($this.data('integer'), 10);

            $this.prop('Counter', 0).animate(
              { Counter: target },
              {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                  // optional: format back with commas
                  $this.text(Math.ceil(now).toLocaleString());
                }
              }
            );

            observer.unobserve(entry.target);
          });
        }
      });
    }

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    $('.counter-block').each(function () {
      observer.observe(this);
    });

  }

  // Social Content

  var $popup = $("#video-popup");
  var $popupInner = $popup.find(".video-popup__inner");
  var $marqueeInner = $(".social-marquee__inner");

  $(document).on("click", ".video-play-btn", function() {
    var videoHtml = $(this).data("video-html");
    $popupInner.html(videoHtml);
    $popup.addClass("active");

    $marqueeInner.addClass("paused");
  });

  $(document).on("click", ".video-popup__close, .video-popup__overlay", function() {
    $popup.removeClass("active");
    $popupInner.html(""); 

    $marqueeInner.removeClass("paused");
  });

  // Accordion 

  $('.accordion--block').each(function () {
    const $accordion = $(this);
    const $items = $accordion.find('.accordion-each');

    if (!$items.length) return;

    // 🔹 find the matching media slider ONLY in this section
    const $section = $accordion.closest('.custom-image--block');
    const $mediaSlider = $section.find('.accordion-media-slider');

    // open first accordion by default
    $items.first().addClass('open').find('.accordion-text').show();

    $accordion.on('click', '.accordion-title', function () {
      const $clicked = $(this).closest('.accordion-each');
      const index = $clicked.data('slide-index');

      // accordion behavior
      $clicked
        .addClass('open')
        .find('.accordion-text')
        .stop(true, true)
        .slideDown(300);

      $items.not($clicked)
        .removeClass('open')
        .find('.accordion-text')
        .stop(true, true)
        .slideUp(300);

      // 🔥 slide ONLY this section’s slider
      if ($mediaSlider.length && $mediaSlider.hasClass('slick-initialized')) {
        $mediaSlider.slick('slickGoTo', index);
      }
    });
  });


  $('.map-tabs-wrapper').each(function () {
    $(this).on('click', '.map-tabs-parent-tab', function () {

      console.log('clicked');

      const first = $(this).data('parentTab');
      const firstAccordionItem = `.map-tabs-parent-content[data-parent-content="${first}"]`;

      console.log(firstAccordionItem, 'firstAccordionItem');

      // get the first `.accordion-text` inside the first `.map-tabs-sub-tab`
      const $firstAccordionText = $(firstAccordionItem)
        .find('.map-tabs-sub-tab')   // select all sub tabs
        .first()                     // pick the first one
        .find('.accordion-text');    // get its accordion content

      // toggle

      console.log($firstAccordionText); 
      $firstAccordionText
        .stop(true, true)
        .slideDown(300);
    });
  });

  // /Product Slider/

  $(function () {
    var $sliders = $('.section-bottom--content__inner.product-slider.slider-stuff');

    if ($sliders.length) {
      $sliders.each(function () {
        var $this = $(this);
        var $products = $this.find('.product-grid-item');

        
        if ($products.length > 1 && !$this.hasClass('slick-initialized')) {
          $this.slick({
            dots: false,
            arrows: false,
            speed: 500,
            autoplay: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
              { 
                breakpoint: 1200, 
                settings: 
              { 
                slidesToShow: 2, 
                slidesToScroll: 1 
              } 
            },
              { 
                  breakpoint: 767, 
                  settings: { 
                    
                    slidesToShow: 1, 
                    slidesToScroll: 1 
                  } 
                
                }
            ]
          });
        }
      });
    }

    $('.custom-product--prev').on('click', function () {
      $sliders.slick('slickPrev');
    });

    $('.custom-product--next').on('click', function () {
      $sliders.slick('slickNext');
    });
  });


  // ------------------------
  // Tabs for .custom-tab
  // ------------------------

  $('.custom-tab').each(function() {
    var $section = $(this);
    var $buttons = $section.find('.tab-buttons');
    var $contents = $section.find('.accordion--each');

    if ($buttons.length && $contents.length) {
   
      $buttons.first().addClass('active');
      $contents.first().addClass('active');

      $buttons.on('click', function() {
        var index = $(this).index(); 

        $buttons.removeClass('active');
        $contents.removeClass('active');

        $(this).addClass('active');       
        $contents.eq(index).addClass('active'); 
      });
    }
  });

  // ------------------------
  // Tabs for .custom-tab--location
  // ------------------------
  $('.custom-tab--location').each(function() {
    var $section = $(this);
    var $buttons = $section.find('.tab-buttons');
    var $contents = $section.find('.tab--each');

    if ($buttons.length && $contents.length) {
      // set first as active
      $buttons.first().addClass('active');
      $contents.first().addClass('active');

      $buttons.on('click', function() {
        var index = $(this).index(); 

        $buttons.removeClass('active');
        $contents.removeClass('active');

        $(this).addClass('active');         
        $contents.eq(index).addClass('active'); 
      });
    }
  });

  // History Slider 

  if ($(".history-slider").length) {
    const $slider = $(".history-slider");
    const $prevBtn = $(".history-prev");
    const $nextBtn = $(".history-next");

    // 1. Function to check and update button states
    function updateNavButtons(slick) {
      // Check Prev Button: disable if we are at the first slide
      if (slick.currentSlide === 0) {
        $prevBtn.addClass("disabled");
      } else {
        $prevBtn.removeClass("disabled");
      }

      // Check Next Button: disable if we are at the last slide
      // Logic: current slide index + number of slides shown >= total slides
      if (slick.currentSlide + slick.options.slidesToShow >= slick.slideCount) {
        $nextBtn.addClass("disabled");
      } else {
        $nextBtn.removeClass("disabled");
      }
    }

    // 2. Attach events BEFORE initializing the slider
    // 'init' fires on page load, 'afterChange' fires after sliding
    $slider.on("init afterChange", function (event, slick) {
      updateNavButtons(slick);
    });

    // 3. Initialize Slick
    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // 4. Click Handlers
    $prevBtn.on("click", function () {
      $slider.slick("slickPrev");
    });

    $nextBtn.on("click", function () {
      $slider.slick("slickNext");
    });
  }


  // Compare 

  if ($('.js-img-compare').length) {
    setTimeout(function() {
      $('.js-img-compare').imagesCompare();
    },200 );
  }

  if($('.sm-tab--block').length) {

    $('.sm-tab--block').each(function(){
      $(this).find('.sm-tab--text__wrapper .sm-tab--text').first().show().siblings().hide();
      $(this).closest('.container').find('.js-img-compare-wrapper .js-img-compare').first().show().siblings().hide();
      $(this).find('.sm-tab--btn').first().addClass('active');
    });
  }
  $('.sm-tab--block .sm-tab--btn a').on('click', function(e) {
    e.preventDefault();
    var $this = $(this);
    var index = $this.parent().index();

    $this.parent().addClass('active').siblings().removeClass('active');

    $this.closest('.container').find('.js-img-compare-wrapper .js-img-compare')
        .eq(index).show()
        .siblings().hide();

    $this.closest('.sm-tab--block').find('.sm-tab--text__wrapper .sm-tab--text')
        .eq(index).show()
        .siblings().hide();
  });


  const classPattern = [
    'sm--image-50', 'sm--image-50', // 1st and 2nd
    'sm--image-40',                 // 3rd
    'sm--image-30', 'sm--image-30', // 4th and 5th
    'sm--image-50', 'sm--image-50', // 6th and 7th
    'sm--image-30', 'sm--image-30', // 8th and 9th
    'sm--image-40'                  // 10th
  ];

  $('.sm-image-block--content').each(function(index) {
    const patternIndex = index % classPattern.length; // Cycle through classPattern
    $(this).addClass(classPattern[patternIndex]);
  });



  // Product Tab

  $(".custom-product .tab-button").on("click", function() {
    var $container = $(this).closest(".custom-product"); 
    var tabId = $(this).data("tab");

    $container.find(".tab-button").removeClass("active");
    $container.find(".tab-content").removeClass("active");

    $(this).addClass("active");
    $container.find("#" + tabId).addClass("active");
  });



  const knifeValues = [4, 5, 7, 10, 14];

  $("#knives").on("input change", function () {
    const pos = $(this).val();
    const value = knifeValues[pos - 1];
    $("#knife-output").text(value);
    $("#knife-input").val(value);
  });


  // Subsciption button 

  var $buttons = $(".custom-subscription-options button");
  var $subTypeInput = $("#subType");
  var $subIntervalInput = $("#subInterval");

  $buttons.on("click", function() {
    // Reset active state
    $buttons.removeClass("active");
    $(this).addClass("active");

    // Get values
    var type = $(this).data("type");
    var interval = $(this).data("interval") || "";

    // Update hidden inputs
    $subTypeInput.val(type);
    $subIntervalInput.val(interval);
  });


  //Tab Accordion

  // $('.custom-tabs-accordion').each(function () {
  //   const $section = $(this);
  //   const $tabLinks = $section.find('.tab-link');
  //   const $tabContents = $section.find('.tab-content');

  //   $tabContents.hide().removeClass('active');
  //   $tabLinks.removeClass('active');

  //   $tabLinks.first().addClass('active');
  //   $tabContents.first().addClass('active').show();

  //   $tabLinks.on('click', function (e) {
  //     e.preventDefault();
  //     const tabId = $(this).data('tab');

  //     $tabLinks.removeClass('active');
  //     $(this).addClass('active');

  //     $tabContents.removeClass('active').hide();
  //     const $activeTab = $section.find('#' + tabId);
  //     $activeTab.addClass('active').show();

  //     const $accordions = $activeTab.find('.tab-accordion-each');
  //     $accordions.removeClass('open').find('.tab-accordion-text').hide();
  //     $accordions.first().addClass('open').find('.tab-accordion-text').show();
  //   });

  //   $section.find('.tab-accordion--block').each(function () {
  //     const $items = $(this).find('.tab-accordion-each');
  //     if (!$items.length) return;

  //     if ($(this).closest('.tab-content').hasClass('active')) {
  //       $items.first().addClass('open').find('.tab-accordion-text').show();
  //     }

  //     $(this).on('click', '.tab-accordion-title', function () {
  //       const $clicked = $(this).closest('.tab-accordion-each');


  //       $clicked.toggleClass('open')
  //         .find('.tab-accordion-text')
  //         .stop(true, true)
  //         .slideToggle(300);

  //       $items.not($clicked)
  //         .removeClass('open')
  //         .find('.tab-accordion-text')
  //         .stop(true, true)
  //         .slideUp(300);
  //     });
  //   });
  // });

  //Pricing Block

  $('.tabs-nav .tab-link').click(function(){
    var tab_id = $(this).data('tab');

    $(this).addClass('active').siblings().removeClass('active');

    $('#' + tab_id).addClass('active').siblings('.tab-content').removeClass('active');
  });

  // Menu Hover 

  const inlineMenu = document.querySelector(".header__inline-menu");
  if (inlineMenu) {
    const detailsItems = inlineMenu.querySelectorAll("details");

    detailsItems.forEach((item) => {
      const ulElement = item.querySelector("ul");
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);

        ulElement.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

        item.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      });
    });
  }

  // if ($(".custom-header .list-menu .header__menu-item .icon-caret").length) {
  //   let timer;

  //   $(".custom-header .list-menu .header__menu-item .icon-caret").on("mouseenter", function() {
  //     clearTimeout(timer);
  //     $(this).closest("details.mega-menu").attr("open", true);
  //   });

  //   $(".custom-header details.mega-menu").on("mouseleave", function() {
  //     let $menu = $(this);
  //     timer = setTimeout(function() {
  //       $menu.removeAttr("open");
  //     }, 100);
  //   }).on("mouseenter", function() {
  //     clearTimeout(timer);
  //   });
  // }

  // Price List 

  if ($(".custom-price-list").length) {

    $(".custom-price-list .tab-link").on("click", function(e){
      e.preventDefault();

      var $wrapper = $(this).closest(".custom-price-list");
      var tab_id = $(this).data("tab");

      $wrapper.find(".tab-link").removeClass("active");
      $wrapper.find(".tab-content").removeClass("active").hide();

      $(this).addClass("active");
      $wrapper.find("#" + tab_id).addClass("active").fadeIn(200);
    });

    $(".custom-price-list").each(function(){
      var $wrapper = $(this);
      $wrapper.find(".tab-content").hide();
      $wrapper.find(".tab-content.active").show();
    });

  }

  // $(function() {
  //   var $details = $('.mega-menu');
  //   var $content = $('.mega-menu__content');

  //   var closeTimeout;

  //   $details.add($content).hover(
  //     function() { 
  //       clearTimeout(closeTimeout); 
  //       $details.attr('open', true);
  //     },
  //     function() { 
  //       closeTimeout = setTimeout(function() {
  //         $details.removeAttr('open');
  //       }, 300); 
  //     }
  //   );
  // });



  var $stickyWrapper = $('<div class="sticky-media-wrapper"></div>').appendTo('body');
  var activeIndex = -1;

  var $blocks = $('.block-each');

  function checkScroll() {
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();

    $blocks.each(function(i){
      var $block = $(this);
      var offsetTop = $block.offset().top;
      var blockHeight = $block.outerHeight();

      // Check if block is in viewport center
      if(scrollTop + windowHeight/2 >= offsetTop && scrollTop + windowHeight/2 < offsetTop + blockHeight){
        if(activeIndex !== i){
          // Switch video
          $stickyWrapper.empty();
          var $video = $block.find('.desktop__display video').first().clone();
          if ($video) {
            $stickyWrapper.append($video);
            $video[0].play();
            activeIndex = i;
          }

        }
      }
    });
  }

  $(window).on('scroll resize', checkScroll);
  checkScroll(); // initial check

  $('.section-media, .custom-media--wrapper').each(function() {
    var $section = $(this);
    var $btn = $section.find('.custom-play-btn');
    var $video = $section.find('video');

    if ($video.length && $btn.length) {
      var videoEl = $video[0];

      videoEl.addEventListener('ended', function() {
        $video.removeAttr('controls'); 
        $btn.fadeIn(200);
        $section.removeClass('playing');
      });

      $btn.on('click', function() {
        videoEl.currentTime = 0;
        videoEl.muted = false;
        $video.attr('controls', true); 
        $section.addClass('playing');

        var playPromise = videoEl.play();
        if (playPromise !== undefined) {
          playPromise.catch(function(error) {
            console.log('Video play failed:', error);
          });
        }

        $btn.fadeOut(200);
      });
    }
  });

  // How it Works

  function initHWMediaTabs() {
    var $allWrappers = $('.main-hw--wrapper');
    var $mediaContainer = $(".content-block--2 .content-block--inner");
    $mediaContainer.show().css('visibility', 'visible');

    var currentWrapper = 0;
    var currentMediaIndex = 0;
    var tabClicked = false;
    var scrollEnabled = true;

    if (!$allWrappers.length) return;

    // --- INITIAL SETUP ---
    $allWrappers.hide().first().show().addClass('active');
    $allWrappers.each(function() {
      const $container = $(this).find('.content-block--2 .content-block--inner');
      const $medias = $container.find('.section-media');
      $container.show();
      $medias.hide().removeClass('active').first().show().addClass('active');
    });
    // $mediaContainer.hide();

    function pauseAllVideos() {
      $('video.custom-video').each(function() { try { this.pause(); } catch(e){} });
    }

    // function showMedia(wrapperIdx, mediaIdx) {
    //   if (!scrollEnabled) return; // skip for mobile
    //   var $wrapper = $allWrappers.eq(wrapperIdx);
    //   var $medias = $wrapper.find('.section-media');
    //   if (!$medias.length) return;

    //   var $prev = $wrapper.find('.section-media.active');
    //   var $next = $medias.eq(mediaIdx);
    //   if ($next.is($prev)) return;

    //    // Always show images
    //   if ($next.find('img').length) {
    //     $next.show().addClass('active');
    //     return;
    //   }

    //   $prev.removeClass('active').hide();
    //   $next.addClass('active').fadeIn(300);

    //   pauseAllVideos();
    //   $next.find('video.custom-video').each(function() {
    //     try { this.currentTime = 0; this.play(); } catch(e){}
    //   });

    //   currentWrapper = wrapperIdx;
    //   currentMediaIndex = mediaIdx;
    // }

    function showMedia(wrapperIdx, mediaIdx) {
    const $wrapper = $allWrappers.eq(wrapperIdx);
    const $container = $wrapper.find('.content-block--2 .content-block--inner');
    const $medias = $container.find('.section-media');

    if (!$medias.length) return;

    // Hide all
    $medias.removeClass('active');

    const $target = $medias.eq(mediaIdx);
    if (!$target.length) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const $video = $target.find('video');

    // -----------------------------
    // MOBILE → recreate video
    // -----------------------------
    if (isMobile && $video.length) {
      const src = $video.data('video-src');
      if (src) {
        $video.remove();

        const newVideo = document.createElement('video');
        newVideo.src = src;
        newVideo.muted = true;
        newVideo.autoplay = true;
        newVideo.playsInline = true;
        newVideo.loop = true;
        newVideo.setAttribute('webkit-playsinline', '');
        newVideo.className = 'custom-video mobile-autoplay';

        $target.find('.section-media--inner').prepend(newVideo);
        newVideo.play().catch(() => {});
      }
    }

    // -----------------------------
    // DESKTOP → just play existing
    // -----------------------------
    if (!isMobile && $video.length) {
      try {
        $video[0].play();
      } catch (e) {}
    }

    $target.show().addClass('active');
  }



    function forceMobileAutoplay($scope) {
      $scope.find('video.mobile-autoplay').each(function () {
        const video = this;
        video.muted = true;
        video.playsInline = true;

        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      });
    }


    function checkVisible() {
      if (!scrollEnabled || tabClicked) return;

      var $visibleWrapper = $allWrappers.filter(':visible.active').first();
      if (!$visibleWrapper.length) return;

      var $sections = $visibleWrapper.find('.hw-each');
      var winTop = $(window).scrollTop();
      var winH = $(window).height();

      var wrapTop = $visibleWrapper.offset().top;
      var wrapBottom = wrapTop + $visibleWrapper.outerHeight();

      // Toggle media container visibility
      if (winTop + winH > wrapTop + 150 && winTop < wrapBottom - 150) {
        if (!$mediaContainer.hasClass('visible')) {
          $mediaContainer.stop(true, true).fadeIn(300).addClass('visible');
        }
      } else {
        if ($mediaContainer.hasClass('visible')) {
          $mediaContainer.stop(true, true).fadeOut(300).removeClass('visible');
        }
      }

      // Show corresponding media
      $sections.each(function(i) {
        var top = $(this).offset().top;
        var bottom = top + $(this).outerHeight();
        if (top < winTop + winH * 0.7 && bottom > winTop + winH * 0.3) {
          showMedia($allWrappers.index($visibleWrapper), i);
          return false;
        }
      });
    }

    // --- TAB BUTTON CLICK ---
    $('.tab-buttons--wrapper .tab-buttons-hw').on('click.hwTabs', function() {
      var wrIdx = parseInt($(this).data('index'), 10);
      if (isNaN(wrIdx)) return;

      tabClicked = true;
      $('.tab-buttons--wrapper .tab-buttons-hw').removeClass('active');
      $(this).addClass('active');

      if (scrollEnabled) {
        // Desktop — normal behavior
        $allWrappers.hide().removeClass('active');
        $allWrappers.eq(wrIdx).show().addClass('active');
      } else {
        // Mobile — show all wrappers but mark active one
        $allWrappers.show().removeClass('active');
        $allWrappers.eq(wrIdx).addClass('active');
        // $('html, body').animate({
        //   scrollTop: $allWrappers.eq(wrIdx).offset().top - 100
        // }, 400);
      }

      $mediaContainer.hide().removeClass('visible');

      var $target = $allWrappers.eq(wrIdx);
      $target.find('.section-media').hide().removeClass('active').first().show().addClass('active');
      // pauseAllVideos();
      $target.find('.section-media').first().find('video.custom-video').each(function() {
        try { this.currentTime = 0; this.play(); } catch(e){}
      });

      currentWrapper = wrIdx;
      currentMediaIndex = 0;

      setTimeout(function() {
        tabClicked = false;
        checkVisible();
      }, 600);
    });

    // --- HANDLE RESIZE ---
    function handleResize() {
      // scrollEnabled = $(window).width() > 767;
      scrollEnabled = !window.matchMedia('(max-width: 767px)').matches;

      if (!scrollEnabled) {
        $mediaContainer.hide().removeClass('visible'); 
        $allWrappers.show().addClass('mobile-visible');
        $allWrappers.each(function() {
          $(this).find('.section-media').show().addClass('active');
        });
      } else {
        $allWrappers.removeClass('mobile-visible').hide().removeClass('active')
          .first().show().addClass('active');

        $allWrappers.each(function() {
          var $medias = $(this).find('.section-media');
          $medias.hide().removeClass('active').first().show().addClass('active');
        });

        checkVisible();
      }
    }

    $(window).on('scroll.hwTabs', checkVisible);
    $(window).on('resize.hwTabs', handleResize);

    handleResize();
    checkVisible();
  }

  $(document).ready(initHWMediaTabs);

  function initTestimonialSlider() {
    const $slider = $('.testimonial-slider');

    if ($(window).width() <= 767) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: $('.testimonial-prev'),
          nextArrow: $('.testimonial-next'),
          dots: false,
          infinite: true,
          adaptiveHeight: true
        });
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initTestimonialSlider();
  $(window).on('resize', initTestimonialSlider);



  function initSocialSlider() {
    const $slider = $('.social-slider');
    const windowWidth = $(window).width();

    if (windowWidth <= 767) {
      const slidesToShow =
        windowWidth <= 360 ? 1 :
        windowWidth <= 590 ? 2 : 3;

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: $('.social-prev'),
          nextArrow: $('.social-next'),
          dots: false,
          infinite: true,
          adaptiveHeight: true
        });
      } else {
        
        const currentSlidesToShow = $slider.slick('slickGetOption', 'slidesToShow');
        if (currentSlidesToShow !== slidesToShow) {
          $slider.slick('slickSetOption', 'slidesToShow', slidesToShow, true);
        }
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initSocialSlider();
  $(window).on('resize', initSocialSlider);




  $('product-form form').on('submit', function(e) {
    var $form = $(this);
    var sectionId = '{{ section.id }}';
    var showRecipient = $('.gift-option-btn.active').data('option') === 'other';

    if (showRecipient) {
      var valid = true;

      // Check all recipient fields
      $form.find('.recipient-info-fields input, .recipient-info-fields textarea').each(function() {
        if (!$(this).val().trim()) {
          valid = false;
          $(this).addClass('error-field'); // highlight empty fields
        } else {
          $(this).removeClass('error-field');
        }
      });

      if (!valid) {
        e.preventDefault(); // STOP the add-to-cart AJAX
        alert('Please fill in all required recipient fields.');
        return false;
      }
    }
  });

  const $mediaSlider = $('.accordion-media-slider');

  $mediaSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    fade: true,
    speed: 400,
    adaptiveHeight: true
  });

});





document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('product-form');
  if (!productForm) return;

  const addToCartButton = productForm.querySelector('button[type="submit"]');
  const recipientFields = document.querySelector('.recipient-info-fields');
  const giftButtons = document.querySelectorAll('.gift-option-btn');

  function toggleRecipientFields(show) {
    if (!recipientFields) return;

    recipientFields.style.display = show ? 'block' : 'none';

    recipientFields.querySelectorAll('input, textarea').forEach(input => {
      input.required = show;

      if (!show) {
        input.value = '';               // ✅ Clear value
        input.classList.remove('error'); // optional if you use error classes
      }
    });

    const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
    if (!show && errorWrapper) {
      errorWrapper.setAttribute('hidden', true);
    }

    updateAddToCartState();
  }

  function updateAddToCartState() {
    const activeBtn = document.querySelector('.gift-option-btn.active');
    const showRecipient = activeBtn?.dataset.option === 'other';

    // If "For Myself" → re-enable button (let Shopify control stock logic)
    if (!showRecipient) {
      addToCartButton.disabled = false;
      return;
    }

    let allFilled = true;

    recipientFields.querySelectorAll('input, textarea').forEach(input => {
      if (!input.value.trim()) {
        allFilled = false;
      }
    });

    addToCartButton.disabled = !allFilled;
  }

  toggleRecipientFields(true);

  giftButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      giftButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      toggleRecipientFields(btn.dataset.option === 'other');
    });
  });

  if (recipientFields) {
    recipientFields.querySelectorAll('input, textarea').forEach(input => {
      input.addEventListener('input', updateAddToCartState);
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  let isDragging = false;

  document.addEventListener("pointerdown", (e) => {
    if (e.target.closest(".product-variant-options__wrapper")) {
      isDragging = true;
    }
  });

  document.addEventListener("pointerup", () => {
    isDragging = false;
  });

  document.addEventListener("pointermove", (e) => {
    if (!isDragging) return;

    const wrapper = e.target.closest(".product-variant-options__wrapper");
    if (!wrapper) return;

    const group = wrapper.closest(".product-form__input--pill");
    if (!group) return;

    const inputs = group.querySelectorAll('input[type="radio"]');

    const x = e.clientX;
    let closest = null;
    let minDist = Infinity;

    inputs.forEach((input) => {
      const label = input.nextElementSibling;
      if (!label) return;

      const rect = label.getBoundingClientRect();
      const center = rect.left + rect.width / 2;

      const dist = Math.abs(x - center);
      if (dist < minDist) {
        minDist = dist;
        closest = input;
      }
    });

    if (closest && !closest.checked) {
      closest.checked = true;
      closest.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
});

function addAnimation(scrollers) {
  scrollers.forEach((scroller) => {
    scroller.setAttribute("data-animated", true);
    const scrollerInner = scroller.querySelector(".logo__wrapper");
    const scrollerContent = Array.from(scrollerInner.children);
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  });
}

$(document).on('cart:updated', function () {
  $.getJSON('/cart.js', function (cart) {
    $('.quick-add__submit').each(function () {
      var $btn = $(this);

      var variantId = $btn
        .closest('product-form')
        .find('input[name="id"]')
        .val();

      if (!variantId) return;

      var itemInCart = cart.items.find(function (i) {
        return i.id == variantId;
      });

      // ALWAYS reset sold-out UI when product is removed
      if (!itemInCart) {
        $btn.removeClass('is-sold-out');
        $btn.prop('disabled', false);

        $btn.find('.sold-out-message').addClass('hidden');
        $btn.find('span:not(.sold-out-message)').removeClass('hidden');
      }
    });
  });
});

(function() {
    // The class name of the container we are waiting for
    const TARGET_SELECTOR = '.Avada-Subscription__Layout-Block4';

    /**
     * This function contains all your layout logic.
     * It is wrapped in a check to ensure we don't process the same element twice.
     */
    function applyCustomLayout(container) {
        // Prevent infinite loops: If we already applied the layout, stop.
        if (container.dataset.layoutApplied === 'true') return;

        const items = Array.from(container.querySelectorAll('.Avada-ModernSelectionBox'));

        // Ensure the app has finished loading all 4 items (1 single + 3 subs)
        if (items.length >= 4) {
            console.log("Target element detected! Applying custom layout...");

            const oneTimeItem = items[0];
            const subscriptionItems = items.slice(1);

            // Create the Separator
            const separator = document.createElement('div');
            separator.className = 'subscription-separator';
            separator.innerHTML = `
                <span class="separator-line"></span>
                <span class="separator-text">GET A SUBSCRIPTION EVERY</span>
                <span class="separator-line"></span>
            `;

            // Rebuild the container structure
            container.innerHTML = '';
            container.appendChild(oneTimeItem);
            container.appendChild(separator);

            // Create a wrapper for the 3 bottom buttons
            const subWrapper = document.createElement('div');
            subWrapper.className = 'subscription-options-wrapper';
            subscriptionItems.forEach(item => subWrapper.appendChild(item));
            container.appendChild(subWrapper);

            // Mark this container as "processed" so the observer doesn't trigger again immediately
            container.dataset.layoutApplied = 'true';
        }
    }

    /**
     * Setup the MutationObserver
     */
    const observer = new MutationObserver((mutations, obs) => {
        const target = document.querySelector(TARGET_SELECTOR);
        
        if (target) {
            applyCustomLayout(target);
            
            /* 
               NOTE: We do NOT call obs.disconnect() here. 
               Why? Because if the subscription app re-renders (e.g., when a user 
               clicks an option), it might wipe out our custom HTML. 
               By staying active, the observer will see the "new" HTML and 
               re-apply our layout automatically.
            */
        }
    });

    // Start observing the entire body for changes in the HTML structure
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Also try running it immediately once, just in case it loaded extremely fast
    const immediateTarget = document.querySelector(TARGET_SELECTOR);
    if (immediateTarget) applyCustomLayout(immediateTarget);

})();